import { SIGNALR_BASE_URL } from '@/config';
import {
    HubConnection,
    HubConnectionBuilder,
    HttpTransportType,
    LogLevel,
} from '@microsoft/signalr';

let getTenantName: () => string = () => '';
let getToken: () => Promise<string> = () => Promise.resolve('');

export const signalrBaseUrl = String(SIGNALR_BASE_URL).replace(/\/+$/, '');

export function setupSignalRConfig(tenantGetter: () => string, tokenGetter: () => Promise<string>) {
    getTenantName = tenantGetter;
    getToken = tokenGetter;
}

export function useSignalRConnection(hub: string): HubConnection {
    const url = `${signalrBaseUrl}/${hub}?t=${getTenantName()}`;

    return new HubConnectionBuilder()
        .withUrl(url, {
            accessTokenFactory: async () => await getToken(),
            transport: HttpTransportType.WebSockets,
            skipNegotiation: true,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();
}
